import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GeneralConfigurationType } from '@consolidocs-ui/types';

export interface GeneralConfigurationState {
  defaultSettings: GeneralConfigurationType | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: GeneralConfigurationState = {
  defaultSettings: null,
  isLoading: false,
  error: null,
};

const generalConfigurationSlice = createSlice({
  name: 'generalConfiguration',
  initialState,
  reducers: {
    setDefaultSettings: (state, action: PayloadAction<GeneralConfigurationType | null>) => {
      state.defaultSettings = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearConfigurations: (state) => {
      state.defaultSettings = null;
      state.error = null;
    },
  },
});

export const {
  setDefaultSettings,
  setLoading,
  setError,
  clearConfigurations,
} = generalConfigurationSlice.actions;

export default generalConfigurationSlice.reducer;

export const generalConfigurationReducer = generalConfigurationSlice.reducer;
